import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import classNames from 'classnames';
import _ from 'lodash';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import DatePicker from '../Common/datePicker';
import { DisabledDatePicker } from '../Common/datePicker';
import InputField from '../Common/inputField';
import { Grid, Row, Col, Panel, Button, Table, Input } from 'react-bootstrap';
import Selection from '../Common/selection';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'

class InventoryRelocationForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            orderNum: 0,

            inventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            },

            relocatedInventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        const { currentInventoryRelocation } = this.props;
        this.props.fetchWarehouses();
        this.props.fetchWarehouseDetail(1);
        if(currentInventoryRelocation) {
          this.props.fetchInventoryRelocationDetail(currentInventoryRelocation.WarehouseRelocation_id)
            .then(() => {
              this.props.fetchInventories();
            });
        }
        else
          this.props.fetchInventories();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventories are ready, reset state.

    componentWillReceiveProps(nextProps) {
      if(nextProps.Default_Warehouse_id && nextProps.Default_Warehouse_id != this.props.Default_Warehouse_id) {
        if(nextProps.Default_Warehouse_id.value)
          this.props.fetchWarehouseDetail(nextProps.Default_Warehouse_id.value);
      }
      if(nextProps.currentInventoryRelocationDetail && nextProps.currentInventoryRelocationDetail != this.props.currentInventoryRelocationDetail) {
        let orderNum = 0;
        let warehouse_Relocation_Line = [...nextProps.currentInventoryRelocationDetail.Warehouse_Relocation_Line];
        warehouse_Relocation_Line.map(relocation => {
          orderNum = Math.max(orderNum, relocation.Pairid);
          relocation.ZoneName = relocation.WarehouseZone_id.Name;
          relocation.BinName = relocation.WarehouseBin_id.Name;
        });
        orderNum = orderNum+1;
        const relocatedInventories = {...this.state.relocatedInventories, rows: warehouse_Relocation_Line };
        this.setState({ relocatedInventories, orderNum: orderNum });
      }
      if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
          let inventories = [];
          inventories = [...nextProps.inventories];
          inventories = inventories.filter(function(obj){
                return obj.BinAmount > 0;
              })
          const newInventories = {...this.state.inventories, rows: inventories }
          this.setState({
              inventories: newInventories
          });
      }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    setInventoryToRelocate(e) {
        e.preventDefault();
        const { inventories, relocatedInventories, orderNum } = this.state;
        const inventoryToLocate = { ...inventories.selectedRows[0],
            Pairid: orderNum,
            Quantity: "-" + this.props.quantityValue
        };

        let inventoryRelocated = { ...inventories.selectedRows[0],
            Pairid: orderNum,
            ZoneName: this.props.toZoneValue.value,
            BinName: this.props.toBinValue,
            Quantity: '+' + this.props.quantityValue
        }

        const newRelocatedInventories = { ...relocatedInventories };
        const newInventories = { ...inventories };
        newRelocatedInventories.rows.push(inventoryToLocate)
        newRelocatedInventories.rows.push(inventoryRelocated)

        // const index = _.findIndex(inventories.rows, { 'Vendor_id': inventories.selectedRows[0].Vendor_id });
        // if (index > -1) {
        //     newInventories.rows.splice(index, 1);
        // }
        // newInventories.selectedRows = [];
        this.setState({
            relocatedInventories: newRelocatedInventories,
            inventories: newInventories,
            orderNum: orderNum+1
        })
    }

    cancelInventoryRelocation(e) {
        e.preventDefault();
        const { inventories, relocatedInventories } = this.state;
        const inventoryToCancel = { ...relocatedInventories.selectedRows[0] };
        const OrderID = relocatedInventories.selectedRows[0].Pairid;

        // const newRelocatedInventories = { ...relocatedInventories };

        let newRelocatedInventoriesRows = [ ...relocatedInventories.rows ];
        // let newInventoriesRows = [ ...inventories.rows ];
        // let newTargetInventoriesRows = [ ...targetInventories.rows ];

        let index = _.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
        if (index > -1 && parseInt(newRelocatedInventoriesRows[index].Quantity) > 0 ) {
            newRelocatedInventoriesRows.splice(index, 1);
            index = _.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
            newRelocatedInventoriesRows.splice(index, 1);
        } else if (index > -1) {
            newRelocatedInventoriesRows.splice(index, 1);
            index = _.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
            newRelocatedInventoriesRows.splice(index, 1);
        }

        let newRelocatedInventories = { ...relocatedInventories, rows: newRelocatedInventoriesRows };

        newRelocatedInventories.selectedRows = [];
        this.setState({
            relocatedInventories: newRelocatedInventories,
        })
    }

    createRelocation(e) {
      e.preventDefault();
      if(this.props.currentInventoryRelocationDetail) {
        if(!this.checkPermission("change_warehouse_relocation"))
          this.props.editInventoryRelocation(
            this.props.currentInventoryRelocationDetail.WarehouseRelocation_id,
            1,
            this.props.postingDate,
            this.props.note,
            Data.Selectors.getRows(this.state.relocatedInventories)
          );
        else
          alert("You have no permission!");
      }
      else
        this.props.createInventoryRelocation(
          1,
          this.props.postingDate,
          this.props.note,
          Data.Selectors.getRows(this.state.relocatedInventories)
        );
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.inventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var inventories = {...this.state.inventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ inventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.inventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const inventories = {...this.state.inventories, filters: newFilters }
                this.setState({ inventories });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const inventories = {...this.state.inventories, selectedRows: rows }
                this.setState({ inventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductName',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ProductDescription',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ProductUnitOfMeasure',
                    name: <Translate value="unit_of_measure" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'BinAmount',
                    name: <Translate value="bin_amount" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ZoneName',
                    name: <Translate value="zone_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'BinName',
                    name: <Translate value="bin_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'Batch_PONum',
                    name: <Translate value="batch_num" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ExpiredDate',
                    name: <Translate value="expired_date" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    formatter: DateFormatter
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryRelocationForm-dataGrid1">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }
    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderRelocatedTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.relocatedInventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var relocatedInventories = {...this.state.relocatedInventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ relocatedInventories: relocatedInventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.relocatedInventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const relocatedInventories = {...this.state.relocatedInventories, filters: newFilters }
                this.setState({ relocatedInventories: relocatedInventories });
            }

            // Handle the Dragable cell function

            const handleCellDrag = e => {
                let { relocatedInventories } = this.state
                let rows = relocatedInventories.rows.slice(0);
                for (let i = e.fromRow; i <= e.toRow; i++) {
                    let rowToUpdate = rows[i];
                    rowToUpdate[e.cellKey] = e.value;
                }
                const newRelocatedInventories = {...relocatedInventories, rows: rows }
                this.setState({
                    relocatedInventories: newRelocatedInventories
                });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let { relocatedInventories } = this.state
                let rows = getRows();//relocatedInventories.rows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                const newRelocatedInventories = {...relocatedInventories, rows: rows }
                this.setState({
                    relocatedInventories: newRelocatedInventories,
                });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const relocatedInventories = {...this.state.relocatedInventories, selectedRows: rows };
                this.setState({ relocatedInventories: relocatedInventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                },
                {
                    key: 'Quantity',
                    name: <Translate value="relocate_quantity" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                    editable: true
                },
                {
                    key: 'ZoneName',
                    name: <Translate value="zone_name" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                    editable: true
                },
                {
                    key: 'BinName',
                    name: <Translate value="bin_name" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                    editable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryRelocationForm-dataGrid2">
                    <ReactDataGrid
                        rowKey='Pairid'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onCellsDragged={handleCellDrag}
                        enableCellSelect={true}
                        onRowUpdated={handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    renderProducts(bin) {
      let products = bin.Product;
      if(products) {
        return products.map(product => {
          return (
            <Row className="marginTopStyle"><Col sm={ 12 }> { product.Name } </Col></Row>
          )
        })
      }
    }

    renderBins() {
        const { currentZoneDetail, bins, detailError, detailIsLoading } = this.props;
        if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
        else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
        if (bins) {
            return bins.map((bin) => {
                const { Name, Description, WarehouseBin_id } = bin;
                return (
                    <Col sm={ 12 }>
                        <Panel>
                            <Row>
                                <Col sm={ 12 }>
                                  <Row><Col sm={ 12 }>
                                        <em className="fa fa-institution marginRightStyle" />
                                        <b><Translate value="bin" /> {Name || <Translate value="name" />}</b>
                                  </Col></Row>
                                  <Row><Col sm={ 12 }>
                                        <em className="fa fa-institution marginRightStyle" />
                                        <b><Translate value="id" /> {WarehouseBin_id || <Translate value="warehousebin_id" />}</b>
                                  </Col></Row>
                                    <Row><Col sm={ 12 }>
                                        <em className="fa fa-building marginLeftStyle marginRightStyle"/>
                                        {currentZoneDetail && currentZoneDetail.Name || <Translate value="zone_name" />}
                                    </Col></Row>
                                  <Row><label>Products:</label></Row>
                                  {this.renderProducts(bin)}
                                </Col>
                            </Row>
                        </Panel>
                    </Col>
                )
            })
        }
    }

    getWarehouseOptions() {
        var warehouseOptions = [];
        this.props.warehouses.map(warehouse => {
            warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name })
        });
        return warehouseOptions;
    }

    getZoneOptions() {
      var zoneOptions = [];
      if(this.props.currentWarehouseDetail){
        this.props.currentWarehouseDetail.Warehouse_Zone.map(zone => {
          zoneOptions.push({ value: zone.Name, label: zone.Name})
        });
      }
      return zoneOptions;
    }

    getZoneOptionsByID() {
      var zoneOptions = [];
      if(this.props.currentWarehouseDetail){
        this.props.currentWarehouseDetail.Warehouse_Zone.map(zone => {
          zoneOptions.push({ value: zone.WarehouseZone_id, label: zone.Name})
        });
      }
      return zoneOptions;
    }

    zoneDetail(e) {
      e.preventDefault();
      this.props.fetchZoneDetail(this.props.Default_WarehouseZone_id.value);
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const inventoryRelocationWarehouseLoc = (<Translate value="inventory_relocation_warehouse_location" />);
        const inventoryRelocationSheetWarehouseLoc = (<Translate value="inventory_relocation_sheet_warehouse_location" />);
        const { inventories, relocatedInventories } = this.state;
        let warehouseOptions = this.getWarehouseOptions();
        let zoneOptions = this.getZoneOptions();
        let zoneOptionsById = this.getZoneOptionsByID();
        return (
            <ContentWrapper>
                <div className="content-heading"><Translate value="inventory_relocation" /></div>
                <Row><Col sm={ 12 }>
                    <Link to="/inventories/relocation"  className="btn btn-green buttonStyle" ><em className="fa fa-mail-reply"/></Link>
                    <div className="pull-right">
                        <button
                          className="btn btn-primary buttonStyle"
                          onClick={(e) => this.createRelocation(e) }>
                          <em className="fa fa-save marginRightStyle" /><Translate value="save" /></button>
                    </div>
                </Col></Row>
              <Col sm = { 9 }>
              <Row className="marginTopStyle">
                    <Col sm={ 12 }>
                        <Panel header={inventoryRelocationWarehouseLoc}>
                            <h4><Translate value="current_inventory" /></h4>
                            <hr/>
                            <p><Translate value="msg_select_an_inventory_to_relocate" /></p>
                            {this.renderTable() }
                            <h4 className="marginTopStyleLarge" ><Translate value="relocation" /></h4>
                            <hr/>
                            <p><Translate value="relocate_some_or_all_of_the_selected_inventory" /></p>
                            <Row>
                                <Col sm={ 6 }>
                                    <Row>
                                        <Col sm={6}><label><Translate value="product_num" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductNum : <Translate value="please_select_an_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="product_name" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductName : <Translate value="please_select_an_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="package_type" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductUnitOfMeasure : <Translate value="please_select_an_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="batch_num" /> (<Translate value="po_num" />)</label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : <Translate value="please_select_an_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="current_zone" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ZoneName : <Translate value="please_select_an_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="current_bin" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].BinName : <Translate value="please_select_an_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="current_quantity" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].BinAmount : <Translate value="please_select_an_inventory" />}</Col>
                                    </Row>
                                </Col>
                                <Col sm={ 6 }>
                                    <Row><Col sm={ 12 }><label><Translate value="relocation_quantity" /></label></Col></Row>
                                    <Row><Col sm={ 12 }>
                                        <Field component={InputField} name="Quantity"></Field>
                                    </Col></Row>
                                    <Row><Col sm={ 12 }>
                                        {inventories.selectedRows[0] &&
                                            parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) &&
                                            <p className="parsley-error-message"><Translate value="msg_relocation_qty_cannot_exceed_current_qty" /></p>}
                                    </Col></Row>
                                  <Row><Col sm={ 12 }><label><Translate value="relocation_destination" /></label></Col></Row>
                                    <Row>
                                        <Col sm={6}>
                                          <label><Translate value="msg_select_warehouse" /></label>
                                          <Field name="Default_Warehouse_id" component={Selection} options={warehouseOptions}/>
                                        </Col>
                                        <Col sm={6}>
                                          <label><Translate value="msg_select_warehouse_zone" /></label>
                                          <Field name="ToZone" component={Selection} options={zoneOptions} />
                                        </Col>
                                        <Col sm={ 6 }>
                                          <label><Translate value="msg_select_warehouse_bin" /></label>
                                          <Field component={InputField} name="ToBin"></Field>
                                        </Col>
                                    </Row>
                                    <button
                                        className="btn btn-primary pull-right"
                                        onClick={(e) => this.setInventoryToRelocate(e) }
                                        disabled={ !inventories.selectedRows[0]
                                                   || parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) }><Translate value="submit" /></button>
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header={inventoryRelocationSheetWarehouseLoc}>
                            <h4><Translate value="inventory_relocation_sheet" /></h4>
                            <hr/>
                            <p><Translate value="list_of_inventory_relocation_lines" /></p>
                            {this.renderRelocatedTable() }
                            <button
                                className="btn btn-warning pull-right marginTopStyle"
                                onClick={(e) => this.cancelInventoryRelocation(e) }
                                disabled={ !relocatedInventories.selectedRows[0] }><Translate value="cancel" /></button>
                        </Panel>
                    </Col>
                </Row>
                <Row>
                    <Col sm={ 7 }>
                        <Col sm={ 6 }><Translate value="relocation_date" />: </Col>
                        <Col sm={ 6 } className="marginBottomStyle">
                            <Field selected={new Date} component={ DisabledDatePicker } name="PostingDate"></Field>
                        </Col>
                        <Col sm={ 6 }><Translate value="modifier" />: </Col>
                        <Col sm={ 6 }>
                            <Field component={InputField} name="Modify_Username"></Field>
                        </Col>
                        <Col sm={ 3 }><Translate value="note" />: </Col>
                        <Col sm={ 9 }>
                            <Field name="Note" component="Textarea" className="form-control" style={{ minHeight: '100px' }}/>
                        </Col>
                    </Col>
                </Row>
                </Col>
                <Col sm={ 3 }>
                  <Row>
                    <Col sm={6}>
                      <label><Translate value="msg_select_warehouse" /></label>
                      <Field name="Default_Warehouse_id" component={Selection} options={warehouseOptions}/>
                    </Col>
                    <Col sm={6}>
                      <label><Translate value="msg_select_warehouse_zone" /></label>
                      <Field name="Default_WarehouseZone_id" component={Selection} options={zoneOptionsById} />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <Button
                        className="btn btn-primary marginLeftStyle"
                        onClick={(e) => this.zoneDetail(e) }>
                        <Translate value="zone_detail" />
                      </Button>
                    </Col>
                  </Row>
                  <Row className="marginTopStyle">
                      <Panel style={{ overflow: "hidden" }}>
                          <Row style={{ overflowY: "scroll", maxHeight: 3*(this.state.tableHeight)}}>
                              { this.renderBins() }
                          </Row>
                      </Panel>
                  </Row>
                </Col>
                <br/>
            </ContentWrapper>
        );
    }
}



export default InventoryRelocationForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryRelocationForm.jsx